module.exports = __webpack_public_path__ + "static/img/6.1c00ee7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/2/zh/6.png
// module id = i0zl
// module chunks = 0